<script lang="ts" setup>
const props = defineProps<{
  data: { label: string; value: string; color?: string; default?: boolean }[];
  dataTestId?: string;
}>();
const value = defineModel<string[]>('value', {
  required: true,
});

const valueWithDefault = computed(() =>
  value.value.length
    ? value.value
    : props.data.filter((el) => el.default).map((el) => el.value),
);
</script>

<template>
  <ToggleGroupRoot
    @update:model-value="value = $event as any"
    :model-value="valueWithDefault"
    type="multiple"
    class="selectButton"
    :data-test-id="dataTestId"
  >
    <ToggleGroupItem
      v-for="item in data"
      :key="item.value"
      :value="item.value"
      :default-value="item.default"
      class="selectButton__item"
      :style="{ '--color': item.color || '#121212' }"
      :data-test-id="dataTestId && `${dataTestId}-item`"
    >
      {{ item.label }}
    </ToggleGroupItem>
  </ToggleGroupRoot>
</template>

<style lang="scss">
.selectButton {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  white-space: nowrap;

  @include mq('sm') {
    flex-wrap: nowrap;
  }

  &__item {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 46px;
    padding: 0 29px;
    border: 1px solid #c0c0c0;
    font-size: 18px;
    color: var(--color);
    transition:
      color 0.3s ease,
      background-color 0.3s ease,
      border-color 0.3s ease;
    border-radius: 30px;
    cursor: pointer;
    background: none;
  }

  &__item:focus,
  &__item:hover {
    border-color: var(--color);
  }

  &__item[data-active='true'] {
    color: #fff;
    background-color: var(--color);
    border-color: var(--color);
  }
}
</style>
